<template lang="pug">
  div()
    app-header(class='u-bg-primary' wrapper-class='u-bg-primary', :white='true')

    div(class='u-bg-landscape u-flex u-items-center' style='min-height:80vh')
      div(class='u-flex o-wrapper u-py5 u-flex-wrap u-items-center u-justify-center')
        div(class=' u-6/12@laptop u-6/12@tablet u-12/12')
          div(class='u-8/12@laptop u-11/12@tablet u-mx-auto u-px2')
            h2(class='u-fz-h1 u-line-1 u-mb4 u-mt0 u-mt0 u-fw-light' data-aos='fade-right' )
              span(class='u-block') {{company.name}} está
              span(class='') para&nbsp;
              span(class='u-color-secondary u-fw-bold') ayudarte

            p(class='u-mb0 u-mt0 u-mb4' data-aos='fade-right' ) Escríbenos y nuestro departamento de consultas se pondrá en contacto para brindarte toda la información que requieras.


        div(class='u-white u-5/12@laptop u-6/12@tablet u-12/12 u-flex-wrap u-flex u-justify-center' data-aos='fade-left' )
          input-validate(:clear='clearForm'
            v-model='form.fullname', :rule='rules.fullname' icon='user' placeholder='Nombres y apellidos', :validation='toggleValidate'
            wrapper-class='c-input c-input--secondary c-input--icon' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

          input-validate(:clear='clearForm'
            v-model='form.whatsapp', :rule='rules.whatsapp' icon='cellphone' placeholder='Whatsapp', :validation='toggleValidate'
            wrapper-class='c-input c-input--secondary c-input--icon' class='u-mb3 u-6/12@tablet  u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

          input-validate(:clear='clearForm'
            v-model='form.email', :rule='rules.email' icon='message' placeholder='Correo electrónico', :validation='toggleValidate'
            wrapper-class='c-input c-input--secondary c-input--icon' class='u-mb3 u-6/12@tablet  u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

          input-validate(:clear='clearForm'
            v-model='form.message', :rule='rules.message' placeholder='¿Cómo podemos ayudarte?', :validation='toggleValidate' type='textarea'
            class='u-mb3 u-12/12 u-px2 c-input c-input--secondary' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')

          div(class='u-12/12 u-px2 u-mb2')
            vue-recaptcha(@expired="form.recaptcha = ''"  ref="recaptcha" @verify="onVerify" sitekey='6LdA-g8UAAAAAEvHOIl8vXLSz9sIsDSe4VgkvMPB')

          div(class='u-px2 u-10/12@tablet u-12/12')
            button(class='c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-mt2' @click='postForm') Enviar correo

    app-footer
    loading(message='Enviando' v-if='isLoading')
    modal-confirm(v-if='isShowModalConfirm' @hide='isShowModalConfirm = false' message='Nos pondremos en contacto con usted.')
    modal-error(v-if='isShowModalError' @hide='isShowModalError = false')
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import Validator from 'validatorjs'

  export default {
    name: 'ContactScreen',
    data () {
      return {
        isShowModalConfirm: false,
        isShowModalError: false,
        toggleValidate: false,
        formValidate: false,
        clearForm: false,
        isLoading: false,
        form: {
          fullname: '',
          email: '',
          whatsapp: '',
          message: '',
          recaptcha: ''
        },
        rules: {
          fullname: 'required',
          email: 'required|email',
          whatsapp: 'required|phone',
          recaptcha: 'required'
        }
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      postForm () {
        this.validate()

        if (this.formValidate && !this.isLoading) {
          this.isLoading = true
          axios.post(`${window.API_URL}/contact`, this.form)
            .then((response) => {
              this.isShowModalConfirm = true
              this.isLoading = false
              let recaptcha = this.form.recaptcha
              this.form = {
                fullname: '',
                email: '',
                whatsapp: '',
                message: '',
                recaptcha: recaptcha
              }
              this.clearForm = true
            })
            .catch(({response}) => {
              this.isLoading = false
              this.isShowModalError = true
            })
        }
      },

      validate () {
        let validation = new Validator(this.form, this.rules)
        validation.passes()
        this.toggleValidate = !this.toggleValidate
        this.formValidate = validation.passes()
      },

      onVerify (value) {
        this.form.recaptcha = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Contact/components/ContactScreen.vue